module.exports = __webpack_public_path__ + "img/algeria.0b701359.svg";